import React, { useState } from "react";
import SideBar from "../../components/sidebar/Sidebar";
import { Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ContrattiTableComponent from "../../components/contratto/ContrattiTableComponent";
import "./Contratto.scss";

const ContrattoPage: React.FC<{}> = () => {

  const [fabVisible, setFabVisible] = useState(true)

  return (
    <div className="home">
      {fabVisible &&
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }} color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      }
      <SideBar />
      <div className="homeContainer">
        <ContrattiTableComponent
          alterFabVisibility={setFabVisible}
          fabVisible={fabVisible}
          enableCreate={true}
          anagrafica_cliente_id={-1}
        />
      </div>
    </div>
  )
}

export default ContrattoPage
